import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import { colors } from './index.js';
import DeadTeddyIcon from '../icons/dead-teddy.js';
export const ErrorCmp = styled.div.withConfig({
  displayName: "error__ErrorCmp",
  componentId: "miprxo-0"
})(["display:flex;align-items:center;color:", ";grid-area:content;justify-content:center;flex-direction:column;svg{margin-bottom:5rem;}"], colors.error);
export const Error = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(ErrorCmp, rest, /*#__PURE__*/React.createElement(DeadTeddyIcon, {
  size: 150
}), children);